export default __webpack_public_path__ + "static/media/messages.2b0d29f6.png";